window.Mustache = require("mustache");
window.moment   = require("moment");
require("moment-timezone");
const axios     = require('axios').default;

class Campaign {

  constructor() {
    this.formdata       = {};
    this.formdata.sdgs  = [];
    this.sdgs_by_sdg_no = [];
  }

  get_axios_instance(){
    var csfr_token  = $('meta[name="csrf-token"]').attr('content');
    return axios.create({
      baseURL: '/api/v1',
      timeout: 5000,
      headers: {'X-CSRF-Token': csfr_token }
    });
  }

  set(form){
    var self = this;
    jquery.each(form, function(key,value){
      self.formdata[key] = value;
    });
  }

  create(cb){
    console.log(this.formdata);
    this.get_axios_instance().post('/campaigns/create', this.formdata)
    .then(function (response) {
      return cb(200, response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, [error.response.data]);
    });    
  }

  update(campaign_id, cb){
    console.log(this.formdata);
    this.get_axios_instance().put('/campaigns/update/'+campaign_id, this.formdata)
    .then(function (response) {
      return cb(200, response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, [error.response.data]);
    });    
  }

  delete(campaign_id, cb){
    this.get_axios_instance().delete('/campaigns/delete/'+campaign_id)
    .then(function (response) {
      return cb(200, response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, [error.response.data]);
    });    
  }

  search(q, cb){
    this.get_axios_instance().get('/campaigns/search?q='+encodeURIComponent(q))
    .then(function (response) {
      return cb(response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, [error.response.data]);
    });    
  }

  get_all_active_campaigns(order_by, cb){
    this.get_axios_instance().get('/campaigns'+(order_by ? '?order_by='+order_by : ''))
    .then(function (response) {
      return cb(response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, [error.response.data]);
    });    
  }

  get_all_sdgs(cb){
    this.get_axios_instance().get('/sdgs')
    .then(function (response) {
      return cb(response.data);
    })
    .catch(function (error) {
      console.log(error);
      return cb(error.response.status, error.response.data);
    });    
  }

  // methods to set / remove and access SDGs by their UUID -> manipulates the "formdata" object directly
  add_sdg(uuid){
    this.formdata.sdgs.push( uuid );
  }

  remove_sdg(uuid){
    this.formdata.sdgs = this.formdata.sdgs.filter(function(obj){
      return (obj != uuid);
    });
  }

  get_sdgs(){
    return this.formdata.sdgs;
  }

  count_sdgs(){
    return this.formdata.sdgs.length;
  }

  // methods to access selected SDGs by their number (sdg_no) -> used for tags (filters)
  add_sdg_no(sdg_no){
    this.sdgs_by_sdg_no.push( sdg_no );
  }

  remove_sdg_no(sdg_no){
    this.sdgs_by_sdg_no = this.sdgs_by_sdg_no.filter(function(obj){
      return (obj != sdg_no);
    });
  }

  get_sdgs_no(){
    return this.sdgs_by_sdg_no;
  }

  validate(page_no, cb){
    var mapbox = new Mapbox;
    var errors = [];
    var self   = this;

    if (page_no == 1){
      if (this.formdata.name.length == 0){
        errors.push("Der Name muss ausgefüllt werden.");
      }
      if (this.formdata.description.length == 0){        
        errors.push("Die Beschreibung muss ausgefüllt werden.");
      }
      if (this.count_sdgs() == 0){        
        errors.push("Es muss mindestens ein SDG ausgewählt werden.");
      }
    }

    if (page_no == 2){
      if (jquery('#campaign-start').val().length != 10){
        errors.push("Das Startdatum und die Uhrzeit müssen ausgefüllt werden.");
      }
      if (jquery('#campaign-end').val().length != 10){
        errors.push("Das Enddatum muss ausgefüllt werden.");
      }
      if (jquery('#campaign-time').val().length != 5){
        errors.push("Die Startzeit muss ausgefüllt werden.");
      }
    }

    if (page_no == 3){
      if (this.formdata.location_name.length == 0){
        errors.push("Die Location muss ausgefüllt werden.");
      }
      if (this.formdata.street.length == 0){
        errors.push("Die Strasse und Hausnummer müssen ausgefüllt werden.");
      }
      if (this.formdata.city.length == 0){
        errors.push("Die Stadt muss ausgefüllt werden.");
      }
    }

    if (this.formdata.latitude && this.formdata.longitude){
      if (! this.formdata.street || !this.formdata.city){
        errors.push('Die Adresse ist nicht ausgefüllt oder unvollständig.');
      }

      if (errors.length >0){
        return cb(false, errors);
      }
      else {
        return cb(true, []);
      }
    }
    else if (this.formdata.street && this.formdata.city){
      mapbox.address_to_geo_coordinates(this.formdata.street+', '+this.formdata.city, function(geo_response){
        console.log(geo_response);
        if (geo_response && geo_response.latitude && geo_response.longitude){
          self.formdata.latitude  = geo_response.latitude;
          self.formdata.longitude = geo_response.longitude;
        }
        else {
          errors.push('Die Adresse konnte leider nicht gefunden werden.')
        }

        if (errors.length >0){
          return cb(false, errors);
        }
        else {
          return cb(true, []);
        }
      });
    }
    else{
      if (errors.length >0){
        return cb(false, errors);
      }
      else {
        return cb(true, []);
      }
    }

  }

}
window.Campaign = Campaign;
